var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.852,
    height: 21.184,
    viewBox: "0 0 22.852 21.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inventory",
    transform: "translate(0.381 0.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M22.28,11.251,19.889,3.346A3.953,3.953,0,0,0,14.96.76L7.006,3.151A4.144,4.144,0,0,0,5.347,4.176L4.615,1.784A2.524,2.524,0,0,0,2.76.076L.857-.363a1.043,1.043,0,1,0-.39,2.05l1.854.39a.419.419,0,0,1,.342.293L4.42,8.079l1.952,6.49a3.709,3.709,0,1,0,6.2,3.806l7.125-2.2A3.913,3.913,0,0,0,22.28,11.251ZM10.715,17.4a1.659,1.659,0,1,1-.9-1.8A1.659,1.659,0,0,1,10.715,17.4Zm8.345-3.172-6.393,2-.049-.2A3.709,3.709,0,0,0,8.226,13.5l-1.854-6A1.945,1.945,0,0,1,7.64,5.1l7.906-2.391A1.905,1.905,0,0,1,17.937,3.98l2.391,7.906A1.835,1.835,0,0,1,19.059,14.228Z",
    transform: "translate(0 0)",
    fill: "#0095f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M225.427,131.244a1.025,1.025,0,0,1-.342-2l1.952-.586a1.025,1.025,0,0,1,.586,1.952l-1.9.586Z",
    transform: "translate(-213.785 -122.725)",
    fill: "#0095f6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.e5c2a26e7c3610e8fcdfe376b21655f9.svg";
export { ForwardRef as ReactComponent };